import React from 'react';
import { Modal, Button } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';
import './OrderConfirmed.scss';

const OrderConfirmed = ({ 
  visible, 
  onClose, 
  onScheduleOnboarding, 
  onSkip 
}) => {
  return (
    <Modal
      centered
      closable
      maskClosable={false}
      visible={visible}
      onCancel={onClose}
      footer={null}
      className="order-confirmed-modal"
      width={480}
    >
      <div className="order-confirmed-content">
        <div className="check-icon-wrapper">
          <CheckCircleOutlined className="check-icon" />
        </div>

        <h2 className="manrope f-24 w-600 lh-44 black-085" style={{ marginBottom: 10, marginTop: 10 }}>
          Your order is confirmed
        </h2>
        
        <p className="manrope f-16 lh-400 lh-24 black-085 text-left mb-32">
          Schedule your onboarding session or skip for now and log into your ALL3D account on desktop to start creating images.
        </p>
        
        <div className="order-confirmed-actions">
          <Button 
            type="primary" 
            className="schedule-button"
            onClick={onScheduleOnboarding}
            block
          >
            Schedule your onboarding session
          </Button>
          
          <Button 
            className="skip-button"
            onClick={onSkip}
            block
          >
            Skip for now
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default OrderConfirmed;

